import { render, staticRenderFns } from "./PixPayment.vue?vue&type=template&id=0321701d&scoped=true&"
import script from "./PixPayment.vue?vue&type=script&lang=ts&"
export * from "./PixPayment.vue?vue&type=script&lang=ts&"
import style0 from "./PixPayment.vue?vue&type=style&index=0&id=0321701d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321701d",
  null
  
)

export default component.exports